!(function (_a, _b) {
  var a = _a ? _a : {}
  var b = _b ? _b : function() { return {};};
  "object" == typeof exports
    ? (module.exports = b())
    : "function" == typeof define && define.amd
    ? define("liTrackClient", [], b)
    : (a.liTrackClient = b())
})(this, function () {
  var a = {
    AJAX_METHOD: "POST",
    DEFAULT_PAGE_TYPE: "ajax",
    globalTrackingUrl: null,
    globalTrackingAppId: "no.app.id",
    lastDisplayMetric: null,
    lastActionMetric: null,
    queue: [],
    maxQueueSize: 1,
    queueTimeout: 1e3,
    timeoutId: null,
    csrfToken: "",
    setProperty: function (a, b) {
      if (b) return void (this[a] = b)
      var c = this.getMetaTag(a)
      return c ? void (this[a] = c.content) : void 0
    },
    setTrackingUrl: function (a) {
      this.setProperty("globalTrackingUrl", a)
    },
    setAppId: function (a) {
      this.setProperty("globalTrackingAppId", a)
    },
    setCsrfToken: function (a) {
      this.setProperty("csrfToken", a)
    },
    getCookieString: function () {
      return document.cookie
    },
    getCsrfToken: function () {
      for (
        var a = "JSESSIONID=", b = this.getCookieString().split(";"), c = 0;
        c < b.length;
        c++
      ) {
        for (var d = b[c]; " " === d.charAt(0); ) d = d.substring(1)
        if (-1 !== d.indexOf(a)) {
          var e = d.substring(a.length, d.length)
          return (
            '"' === e[0] &&
              '"' === e[e.length - 1] &&
              (e = e.substring(1, e.length - 1)),
            e
          )
        }
      }
      return ""
    },
    createXmlHttpObject: function () {
      try {
        return new XMLHttpRequest()
      } catch (a) {}
      return null
    },
    ajax: function (a, b, c) {
      var d
      return this.globalTrackingUrl
        ? ((d = this.createXmlHttpObject()),
          void (
            d &&
            (d.open(this.AJAX_METHOD, this.globalTrackingUrl, !0),
            (d.withCredentials = !0),
            d.setRequestHeader("Content-type", "application/json"),
            this.csrfToken
              ? d.setRequestHeader("Csrf-Token", this.csrfToken)
              : d.setRequestHeader("Csrf-Token", this.getCsrfToken()),
            (d.onreadystatechange = function () {
              return 4 === d.readyState
                ? 200 !== d.status && 304 !== d.status
                  ? void (c && c("Request returned " + d.status))
                  : void ("function" == typeof b && b(d))
                : void 0
            }),
            4 !== d.readyState && d.send(a))
          ))
        : void (c && c("Tracking url is not defined"))
    },
    flush: function () {
      var a = this
      this.ajax(JSON.stringify(this.queue), null, a.logError),
        (this.queue = []),
        clearTimeout(this.timeoutId),
        (this.timeoutId = null)
    },
    addToQueue: function (a) {
      if ((this.queue.push(a), this.queue.length >= this.maxQueueSize))
        return this.flush()
      if (!this.timeoutId) {
        var b = this
        this.timeoutId = setTimeout(function () {
          b.flush()
        }, this.queueTimeout)
      }
    },
    track: function (a) {
      return "object" != typeof a
        ? void this.logError("Track data must be an object")
        : ((a = this.fillMissingData(a)), void this.addToQueue(a))
    },
    trackWithCallback: function (a, b) {
      var c = this
      if ("object" != typeof a)
        return void this.logError("Track data must be an object")
      a = this.fillMissingData(a)
      var d = JSON.stringify(a)
      this.ajax(
        d,
        function (a) {
          "function" == typeof b && b(null, a.responseText)
        },
        function (a) {
          c.logError(a), "function" == typeof b && b(a)
        }
      )
    },
    getTimestamp: function () {
      return Math.round(new Date().getTime() / 1e3)
    },
    getTrackingCode: function (a) {
      return a.eventBody.trackingCode
        ? a.eventBody.trackingCode
        : "PageViewEvent" === a.eventInfo.eventName
        ? "full" === a.eventBody.pageType
          ? ((this.lastDisplayMetric = a.eventBody.requestHeader.pageKey),
            this.lastActionMetric)
          : ((this.lastActionMetric = a.eventBody.requestHeader.pageKey),
            this.lastDisplayMetric)
        : null
    },
    fillMissingData: function (a) {
      if (!a.eventInfo) return this.logError("You must specify eventInfo")
      if (
        (a.eventInfo.appId || (a.eventInfo.appId = this.globalTrackingAppId),
        !a.eventBody)
      )
        return this.logError("You must specify eventBody")
      a.eventBody.trackingCode = this.getTrackingCode(a)
      var b = a.eventBody.trackingInfo || {}
      b.clientTimestamp || (b.clientTimestamp = this.getTimestamp()),
        (a.eventBody.trackingInfo = b)
      var c = a.eventBody.requestHeader || {}
      return (
        c.pageKey || (c.pageKey = this.lastDisplayMetric),
        (a.eventBody.requestHeader = c),
        a
      )
    },
    trackPageView: function (a) {
      var b, c, d, e
      "string" == typeof a
        ? ((b = a), (e = this.DEFAULT_PAGE_TYPE))
        : ((b = a.pageKey),
          (e = a.pageType || this.DEFAULT_PAGE_TYPE),
          (c = a.trackingCode),
          (d = a.trackingInfo))
      var f = {
        eventInfo: { eventName: "PageViewEvent" },
        eventBody: { requestHeader: { pageKey: b }, pageType: e },
      }
      return (
        c && (f.eventBody.trackingCode = c),
        d && (f.eventBody.trackingInfo = d),
        b ? void this.track(f) : this.logError("You must provide a pageKey")
      )
    },
    trackUnifiedAction: function (a) {
      if (!a.action) return this.logError("You must provide action")
      if (!a.sponsoredFlag)
        return this.logError("You must provide sponsoredFlag")
      var b = { eventInfo: { eventName: "UnifiedActionEvent" }, eventBody: a }
      this.track(b)
    },
    trackArticleView: function (a) {
      if (!a.articleId) return this.logError("You must provide articleId")
      var b = { eventInfo: { eventName: "ArticleViewEvent" }, eventBody: a }
      this.track(b)
    },
    trackUnifiedImpression: function (a) {
      if (!a.results) return this.logError("You must provide results")
      var b = {
        eventInfo: { eventName: "UnifiedImpressionEvent" },
        eventBody: a,
      }
      this.track(b)
    },
    logError: function (a) {
      var b = window.console
      b && b.error && b.error(a)
    },
    getMetaTag: function (a) {
      var b,
        c,
        d,
        e =
          document.getElementById(a) ||
          (document.querySelector &&
            document.querySelector("meta[name=" + a + "]"))
      if (e) return e
      for (
        b = document.getElementsByTagName("meta"), d = b.length, c = 0;
        d > c;
        c++
      )
        if (b[c].getAttribute("name") === a) return b[c]
      return null
    },
    init: function () {
      this.setTrackingUrl(), this.setAppId()
    },
  }
  return a.init(), a
})
